export const environment = {
  production: false,
  provideAuth0: {
    domain: 'diazar.us.auth0.com',
    clientId: '2WmaYM4F3DX9GndrPeAEPNbPQmTbMVQR',
    cacheLocation: 'localstorage',
    authorizationParams: {
      redirect_uri: window.location.origin,
      scope: "openid profile email offline_access",
      audience: 'https://controldeusuarios.diazar.com'
    },
  },
  baseURL: 'https://dzw.dev.diazar.com/api',
  usersControlUrl: 'controldeusuarios.qa.diazar.com/user-info',
  firebaseConfig :{
    apiKey: "AIzaSyBIaorKWhEmK_R2c5aGRqzpOapiyknsIGw",
    authDomain: "diazarcontrol-2ac23.firebaseapp.com",
    projectId: "diazarcontrol-2ac23",
    storageBucket: "diazarcontrol-2ac23.firebasestorage.app",
    messagingSenderId: "958696246802",
    appId: "1:958696246802:web:8803234b1ad049ea43d2cb",
    measurementId: "G-FWD3VK91EP"
  },
  environment: 'develop',
  mixpanelToken: '76c124ad4cece5c2a34559070d3b4381'
}
